import { useSyncExternalStore } from 'react';

export type Breakpoint = 'mobile' | 'tablet' | 'desktop';

const mdQuery = '(min-width: 768px)';
const lgQuery = '(min-width: 1024px)';

function getBreakpoint(): Breakpoint {
  if (typeof window === 'undefined') return 'desktop';
  if (window.matchMedia(lgQuery).matches) return 'desktop';
  if (window.matchMedia(mdQuery).matches) return 'tablet';
  return 'mobile';
}

let current = getBreakpoint();
const listeners = new Set<() => void>();

if (typeof window !== 'undefined') {
  const update = () => {
    const next = getBreakpoint();
    if (next !== current) {
      current = next;
      listeners.forEach((l) => l());
    }
  };
  window.matchMedia(mdQuery).addEventListener('change', update);
  window.matchMedia(lgQuery).addEventListener('change', update);
}

export function useBreakpoint(): Breakpoint {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => current,
  );
}
